export const greekLOT = [
    // Grave accent (; + vowel)
    { match: /;a/, replace: "ὰ" },  // alpha with grave
    { match: /;e/, replace: "ὲ" },  // epsilon with grave
    { match: /;i/, replace: "ὶ" },  // iota with grave
    { match: /;u/, replace: "ὺ" },  // upsilon with grave
    { match: /;o/, replace: "ὸ" },  // omicron with grave
    { match: /;w/, replace: "ὼ" },  // omega with grave
    { match: /;h/, replace: "ὴ" },  // eta with grave

    // Acute accent (' + vowel)
    { match: /'a/, replace: "ά" },  // alpha with acute
    { match: /'e/, replace: "έ" },  // epsilon with acute
    { match: /'i/, replace: "ί" },  // iota with acute
    { match: /'o/, replace: "ό" },  // omicron with acute
    { match: /'u/, replace: "ύ" },  // upsilon with acute
    { match: /'w/, replace: "ώ" },  // omega with acute
    { match: /'h/, replace: "ή" },  // eta with acute

    // Circumflex (: + vowel)
    { match: /:a/, replace: "ᾶ" },  // alpha with circumflex
    { match: /:i/, replace: "ῖ" },  // iota with circumflex
    { match: /:u/, replace: "ῦ" },  // upsilon with circumflex
    { match: /:h/, replace: "ῆ" },  // eta with circumflex
    { match: /:\/h/, replace: "ῇ" }, // eta with circumflex and iota subscript
    { match: /:w/, replace: "ῶ" },  // omega with circumflex

    // Smooth breathing (j + vowel)
    { match: /ja/, replace: "ἀ" },  // alpha with smooth breathing
    { match: /je/, replace: "ἐ" },  // epsilon with smooth breathing
    { match: /ji/, replace: "ἰ" },  // iota with smooth breathing
    { match: /jo/, replace: "ὀ" },  // omicron with smooth breathing
    { match: /ju/, replace: "ὐ" },  // upsilon with smooth breathing

    // Rough breathing (J + vowel)
    { match: /Ja/, replace: "ἁ" },  // alpha with rough breathing
    { match: /Je/, replace: "ἑ" },  // epsilon with rough breathing
    { match: /Ji/, replace: "ἱ" },  // iota with rough breathing
    { match: /Jo/, replace: "ὁ" },  // omicron with rough breathing
    { match: /Ju/, replace: "ὑ" },  // upsilon with rough breathing

    // Standalone breathing marks
    { match: /=/, replace: "᾽" },   // apostrophe/koronis (smooth breathing mark)
    { match: /\+/, replace: "῾" },  // rough breathing mark

    // Smooth breathing + acute ([ + vowel)
    { match: /\[a/, replace: "ἄ" }, // alpha with smooth breathing and acute
    { match: /\{a/, replace: "ἅ" }, // alpha with rough breathing and acute
    { match: /\[e/, replace: "ἔ" }, // epsilon with smooth breathing and acute
    { match: /\{e/, replace: "ἕ" }, // epsilon with rough breathing and acute
    { match: /\[i/, replace: "ἴ" }, // iota with smooth breathing and acute
    { match: /\{i/, replace: "ἵ" }, // iota with rough breathing and acute
    { match: /\[o/, replace: "ὄ" }, // omicron with smooth breathing and acute
    { match: /\{o/, replace: "ὅ" }, // omicron with rough breathing and acute
    { match: /\[u/, replace: "ὔ" }, // upsilon with smooth breathing and acute
    { match: /\{u/, replace: "ὕ" }, // upsilon with rough breathing and acute
    { match: /\[h/, replace: "ἤ" }, // eta with smooth breathing and acute
    { match: /\{h/, replace: "ἥ" }, // eta with rough breathing and acute

    // Iota subscript (/ + vowel)
    { match: /\/a/, replace: "ᾳ" }, // alpha with iota subscript
    { match: /\/h/, replace: "ῃ" }, // eta with iota subscript

    // Basic lowercase letters
    { match: /a/, replace: "α" },   // alpha
    { match: /b/, replace: "β" },   // beta
    { match: /c/, replace: "χ" },   // chi
    { match: /d/, replace: "δ" },   // delta
    { match: /e/, replace: "ε" },   // epsilon
    { match: /f/, replace: "φ" },   // phi
    { match: /g/, replace: "γ" },   // gamma
    { match: /h/, replace: "η" },   // eta
    { match: /i/, replace: "ι" },   // iota
    { match: /k/, replace: "κ" },   // kappa
    { match: /l/, replace: "λ" },   // lambda
    { match: /m/, replace: "μ" },   // mu
    { match: /n/, replace: "ν" },   // nu
    { match: /o/, replace: "ο" },   // omicron
    { match: /p/, replace: "π" },   // pi
    { match: /q/, replace: "θ" },   // theta
    { match: /r/, replace: "ρ" },   // rho
    { match: /s/, replace: "σ" },   // sigma
    { match: /t/, replace: "τ" },   // tau
    { match: /u/, replace: "υ" },   // upsilon
    { match: /w/, replace: "ω" },   // omega
    { match: /x/, replace: "ξ" },   // xi
    { match: /y/, replace: "ψ" },   // psi
    { match: /z/, replace: "ζ" },   // zeta

    // Capital letters (Shift + key)
    { match: /A/, replace: "Α" },   // Alpha
    { match: /B/, replace: "Β" },   // Beta
    { match: /C/, replace: "Χ" },   // Chi
    { match: /D/, replace: "Δ" },   // Delta
    { match: /E/, replace: "Ε" },   // Epsilon
    { match: /F/, replace: "Φ" },   // Phi
    { match: /G/, replace: "Γ" },   // Gamma
    { match: /H/, replace: "Η" },   // Eta
    { match: /I/, replace: "Ι" },   // Iota
    { match: /K/, replace: "Κ" },   // Kappa
    { match: /L/, replace: "Λ" },   // Lambda
    { match: /M/, replace: "Μ" },   // Mu
    { match: /N/, replace: "Ν" },   // Nu
    { match: /O/, replace: "Ο" },   // Omicron
    { match: /P/, replace: "Π" },   // Pi
    { match: /Q/, replace: "Θ" },   // Theta
    { match: /R/, replace: "Ρ" },   // Rho
    { match: /S/, replace: "Σ" },   // Sigma
    { match: /T/, replace: "Τ" },   // Tau
    { match: /U/, replace: "Υ" },   // Upsilon
    { match: /V/, replace: "ς" },   // Final sigma (lowercase word-final form)
    { match: /W/, replace: "Ω" },   // Omega
    { match: /X/, replace: "Ξ" },   // Xi
    { match: /Y/, replace: "Ψ" },   // Psi
    { match: /Z/, replace: "Ζ" },   // Zeta
];
